import useSWR from 'swr'
import { swrFetcher } from './helpers'
import { Patient } from './aboboApiTypes'
import { useNavigate } from '@tanstack/react-router'

export const useMe = () => {
  const navigate = useNavigate()
  const { data: response, error, isLoading, mutate } = useSWR('/patients/me', swrFetcher<Patient>, {
    onError: (err, key, config: any) => {
      if (err.status != 401 || typeof response === 'undefined') return;
      // Clear all cache entries except branding to preserve branding data
      const cacheKeys = Array.from(config.cache.keys());
      cacheKeys.forEach(cacheKey => {
        if (cacheKey !== '/client/brand') {
          config.cache.delete(cacheKey);
        }
      });
      navigate({ to: '/secure/login', replace: true });
    }
  })

  return {
    me: response?.data,
    mutate,
    isLoading,
    isError: error
  }
}